// openLivestreamAlert.js
'use strict';
import { LIVESTREAM_CUE_CARD_DISPLAY_DURATION_SECONDS } from '../RemoteConfigKeys.js';

import toggleModal from '../action/toggleModal.js';
import closeModalAfterSeconds from '../action/closeModalAfterSeconds.js';

import getRemoteConfigData from '../selector/getRemoteConfigData.js';

/**
 * Open livestream alert
 * @kind action
 * @param {string} {text} - livestream alert text.
 * @return {Promise} Action promise.
 */
const openLivestreamAlert =
  ({ text }) =>
  async (dispatch, getState) => {
    dispatch(
      toggleModal({
        modalId: 'LivestreamAlertModal',
        isOpen: true,
        payload: {
          text,
        },
      })
    );
    dispatch(
      closeModalAfterSeconds({
        modalId: 'LivestreamAlertModal',
        seconds: getRemoteConfigData(
          getState(),
          LIVESTREAM_CUE_CARD_DISPLAY_DURATION_SECONDS
        ),
      })
    );
  };

export default openLivestreamAlert;
